const formattedDate = date => {

  const jsDate = new Date(date);

  const hour = jsDate.getHours().toString().padStart(2,'0');
  const minute = jsDate.getMinutes().toString().padStart(2,'0');
  const second = jsDate.getSeconds().toString().padStart(2,'0');
  const time = `${hour}:${minute}:${second}`;

  const day = jsDate.getDate().toString().padStart(2,'0');
  const month = (jsDate.getMonth() + 1).toString().padStart(2,'0');
  const year = jsDate.getFullYear().toString().padStart(2,'0');
  const formattedDate = `${day}/${month}/${year}`;

  return `${time} ${formattedDate}`;

};

export default formattedDate;


// WEBPACK FOOTER //
// ./src/components/content/feedback/utils/formattedDate.js